module.exports = __webpack_public_path__ + "static/media/logo_option2.18850834.png";